import { render, staticRenderFns } from "./FabricCutter.vue?vue&type=template&id=a451804c&scoped=true"
import script from "./FabricCutter.vue?vue&type=script&lang=js"
export * from "./FabricCutter.vue?vue&type=script&lang=js"
import style0 from "./FabricCutter.vue?vue&type=style&index=0&id=a451804c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a451804c",
  null
  
)

export default component.exports